<template>
  <div class="container-fluid">
    <!-- d-none d-md-block will hide the alert on any screen size that is smaller than what is considered 'medium' which appears to be ipad & ipad pro size (10/12 inches) -->
    <div class="d-none d-md-block">
      <b-alert show dismissible variant="info">
        Don't forget to interact with these models using your cursor/scroll wheel and also view them on your mobile device in <b>Augmented Reality!</b>
        <br>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-play-btn-fill" viewBox="2 2 16 16">
          <path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>
        </svg>
        <a href="" @click="showModal" data-toggle="modal" style="color:red;" ><b>Click here for a video demo</b></a>
      </b-alert>
      <!-- Styling and layout for video modal that is called in the above b-alert -->
      <b-modal ref="video-modal" size="xl" hide-footer title="Don't forget! - Augmented Reality compatible browsers are listed on bottom of the website.">
        <!-- <i>Don't forget to make sure you are on a compatible browser for Augmented Reality. This is shown on the bottom of the website.</i> -->
        <div class="d-block text-center">
          <br>
          <div class="embed-responsive embed-responsive-16by9">
            <video id="videodemo" src="/assets/VideoDemo.mp4" type="video/mp4" controls autoplay>Video demonstration</video>
          </div>
        </div>
        <!-- <br> -->
        <b-button class="mt-3" variant="outline-dark" block @click="hideModal">Close</b-button>
      </b-modal>
    </div>

    <!-- v1.8.0 + does automatic conversions of .glb to usdz. We no longer need to specify both types of models. Andriod/desktop will natively use glb. -->
    <model-viewer
      v-if="isMounted"
      v-bind:src="this.model"
      camera-controls
      shadow-intensity="1"
      orbit-sensitivity="1.25"
      camera-orbit="60deg 60deg 100%"
      auto-rotate
      ar ar-modes="webxr scene-viewer quick-look"
    >

      <div class="d-xs-block d-lg-none">
        <p id='ar-notify-text'>
          View in
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-badge-ar-fill" viewBox="0 1.5 16 16">
            <path d="m6.031 8.574-.734-2.426h-.052L4.51 8.574h1.52zm3.642-2.641v1.938h1.033c.66 0 1.068-.316 1.068-.95 0-.64-.422-.988-1.05-.988h-1.05z"/>
            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm4.265 5.458h2.004L6.739 11H8L5.996 5.001H4.607L2.595 11h1.2l.47-1.542zM8.5 5v6h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9H8.5z"/>
          </svg>
        </p>
      </div>

    </model-viewer>

    <b-dropdown size="md" v-bind:text="this.userSelection" variant="outline-dark" class="m-2">
      <b-dropdown-group id="t2-pods" header="T2 Desk Setups">
        <b-dropdown-item @click="updateSelection('4ROW')">4 Row</b-dropdown-item>
        <b-dropdown-item @click="updateSelection('4POD')">4 Pod</b-dropdown-item>
        <b-dropdown-item @click="updateSelection('8POD')">8 Pod</b-dropdown-item>
      </b-dropdown-group>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-group id="t2-atrium" header="T2 Atrium">
        <b-dropdown-item @click="updateSelection('MainAtrium')">Atrium</b-dropdown-item>
      </b-dropdown-group>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-group id="t2-collab" header="T2 Collab Space">
        <b-dropdown-item @click="updateSelection('CollabAtrium')">Atrium</b-dropdown-item>
        <b-dropdown-item @click="updateSelection('CollabPod')">Pods</b-dropdown-item>
        <b-dropdown-item @click="updateSelection('CollabCouch')">Couch</b-dropdown-item>
        <b-dropdown-item @click="updateSelection('CollabChairs')">Chairs</b-dropdown-item>
        <b-dropdown-item @click="updateSelection('CollabBoards')">Huddle Boards</b-dropdown-item>
      </b-dropdown-group>
    </b-dropdown>
    
    <footer>
      <ul style="font-size:14px">AR supported browsers :</ul>
      <ul>
        <li>
          <!-- <img src="https://img.icons8.com/dusk/26/000000/android.png"/> -->
          <b>Android - </b>
          <!-- <img src="../assets/samsung-browser-icon.png" class="d-inline-block align-center" width="20" height="20"/> -->
          <img src="https://img.icons8.com/color/24/000000/chrome--v1.png"/>
          <img src="https://img.icons8.com/color/24/000000/ms-edge-new.png"/>
          <img src="https://img.icons8.com/fluency/24/000000/opera.png"/>
          <img src="https://img.icons8.com/color/24/000000/brave-web-browser.png"/>
        </li>
        <li>
          <!-- <img src="https://img.icons8.com/color/34/000000/ios-logo.png"/> -->
          <b>IOS - </b>
          <!-- <img src="https://img.icons8.com/color/14/000000/chrome--v1.png"/>
          <img src="https://img.icons8.com/color/14/000000/ms-edge-new.png"/> -->
          <img src="https://img.icons8.com/color/24/000000/safari--v1.png"/>
          <!-- <img src="https://img.icons8.com/fluency/14/000000/opera.png"/>
          <img src="https://img.icons8.com/color/15/000000/brave-web-browser.png"/> -->
        </li>
        <li><i>In partnership with INVISTA IT Architecture & XR Teams.</i></li>
      </ul>
   </footer>

  </div>
  
</template>

<script>
import '@google/model-viewer';
import {  isChrome, isEdge, isIOS, isMobile, isMobileSafari, isOpera, isSafari } from 'mobile-device-detect';

export default {
  name: 'Home',
  data: function() {
    return {
      isMounted: false,
      userSelection: "",
      device: "",
      model: ""
    };
  },
  mounted() {
    this.isMounted = true;
    this.model = "./assets/4ROW.glb" // initial mounted model
    this.userSelection = '👋 Selected : ' + '4ROW'
    this.device = isMobile ? isIOS ? 'ios':'android':'desktop' // check what device user is on
    //Browser Compatibility 
    const currentdevice = this.device;
    // var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var isBrave = navigator.brave && navigator.brave.isBrave()
    if (currentdevice == 'ios'){
      if (isSafari || isMobileSafari ) {
        console.log("Recommended browser is used")
      }
      else {
        alert ("FYI: You are Not using a compatible browser. Please use Safari on iPhone for best experience of AR.")
      }
    }; 
    if (currentdevice == 'android'){
      if (isChrome || isEdge || isOpera || isBrave) {
        console.log("Recommended browser is used")
      }
      else {
        alert ("FYI: You are Not using a compatible browser. Please use Chrome, MS edge, Opera or Brave on Android for best experience of AR.")
      }
    }; 
  },
  methods:{
    // MODAL - Video
    showModal() {
      this.$refs['video-modal'].show()
    },
    hideModal() {
      this.$refs['video-modal'].hide()
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['video-modal'].toggle('#toggle-btn')
    },

    updateSelection: function($event) {
      // model details
      const modelDir = './assets/';
      const modelName = $event;
      const modelPath = modelDir + modelName + '.glb';

      // set the model viewer new model with user selection
      this.userSelection = '👋 Selected : ' + modelName;
      this.model = modelPath;

      // detect device, detect selected model, warn user that it may not be usable with AR.
      const currentdevice = this.device;
      if (modelName == 'MainAtrium' || modelName == 'CollabAtrium'){
        if (currentdevice == 'android' || currentdevice == 'ios'){
          alert ("FYI: Large model, it may have issues rendering in AR.");
        };
      };

      // Log details
      console.log('user device : ' + this.device)
      console.log('model path : ' + this.model)
    }
  } 
};

</script>

<style scoped>

  footer {
    position: relative;
    padding: 30px 30px 0px 0px;
    bottom: 0px;
    width: auto;
    height: 100px;
  }

  h3 {
    margin: 10px 0 0;
  }

  ul {
    list-style-type: none;
    margin: auto;
    padding: auto;
    text-align: center;
  }

  li {
    text-align: center;
    margin: auto;
    text-align: center;
  }

  a {
    color: #2c3e50;
    font-size: 100%;
  }

  b {
    color: #2c3e50;
    font-size: 100%;
  }

  model-viewer {
    border-radius: 20px;
    /* border: 2px solid #DADCE0; */
    width: 100%;
    height: 525px;
    background-color: #F1F8FE;
    overflow-x: hidden;
  }

  #ar-notify-text {
    /* used to get the text in a position that stays rather consistent based on multiple devices  */
    transform: translate(39%, 2050%);
    font-family: Roboto Regular, Helvetica Neue, sans-serif;
    font-size: 11px;
  }

  .slider {
    width: auto;
    overflow: hidden;
    position: relative;
  }

  .slides {
    display: flex;
    overflow-x: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
  }

  .slide {
    scroll-snap-align: start;
    flex-shrink: 0;
    width: 50px;
    height: 50px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #fff;
    margin-top: 20px;
    margin-bottom: auto;
    margin-right: auto !important;
    margin-left: auto !important;
    border-radius: 15px;
    border-color: #2c3e50;
    display: flex;
  }

  .slide.selected {
    border: 3px solid #4285f4;
  }

  .slide:focus {
    outline: none;
  }

  .slide:focus-visible {
    outline: 1px solid #4285f4;
  }

</style>
